import React, { useState } from "react";
import { useCreatePartnerMutation } from "@/features/api/partnersApi";

const partnershipOptions = [
  { key: "studyAbroad", label: "Study Abroad Consultancy" },
  // { key: "workPermit", label: "Work Permit Services" },
  { key: "visitorVisa", label: "Visitor Visa Services" },
  { key: "englishTeaching", label: "English Language Teaching" },
];

const communicationMethods = ["Email", "Phone", "Video Call"];

const initialPartnershipTypes = {
  studyAbroad: false,
  // workPermit: false,
  visitorVisa: false,
  englishTeaching: false,
  otherChecked: false,
  otherText: "",
};

const BecomePartnerForm = () => {
  const [createPartner, { isLoading }] = useCreatePartnerMutation();

  const [form, setForm] = useState({
    fullName: "",
    email: "",
    phone: "",
    orgName: "",
    orgWebsite: "",
    partnershipTypes: { ...initialPartnershipTypes },
    orgDescription: "",
    whyPartner: "",
    preferredContact: "",
    candidatesSent: "",
    comments: "",
    consent: false,
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name === "otherChecked") {
      setForm((prev) => ({
        ...prev,
        partnershipTypes: {
          ...prev.partnershipTypes,
          otherChecked: checked,
          otherText: checked ? prev.partnershipTypes.otherText : "",
        },
      }));
    } else if (name === "otherText") {
      setForm((prev) => ({
        ...prev,
        partnershipTypes: {
          ...prev.partnershipTypes,
          otherText: value,
        },
      }));
    } else if (Object.keys(form.partnershipTypes).includes(name)) {
      setForm((prev) => ({
        ...prev,
        partnershipTypes: {
          ...prev.partnershipTypes,
          [name]: checked,
        },
      }));
    } else if (name === "consent") {
      setForm((prev) => ({ ...prev, consent: checked }));
    } else if (type === "radio") {
      setForm((prev) => ({ ...prev, [name]: value }));
    } else {
      setForm((prev) => ({ ...prev, [name]: value }));
    }
  };

  const validateForm = () => {
    if (!form.fullName.trim()) {
      alert("Full Name is required.");
      return false;
    }
    if (!form.email.trim()) {
      alert("Email is required.");
      return false;
    }
    if (!form.phone.trim()) {
      alert("Phone Number is required.");
      return false;
    }
    if (!form.consent) {
      alert("You must provide consent.");
      return false;
    }
    if (form.partnershipTypes.otherChecked && !form.partnershipTypes.otherText.trim()) {
      alert("Please specify the 'Other' partnership type.");
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    const selectedTypes = Object.entries(form.partnershipTypes)
      .filter(
        ([key, val]) =>
          key !== "otherChecked" &&
          key !== "otherText" &&
          val === true
      )
      .map(([key]) => key);

    if (form.partnershipTypes.otherChecked) {
      selectedTypes.push(form.partnershipTypes.otherText.trim());
    }

    const payload = {
      fullName: form.fullName.trim(),
      email: form.email.trim(),
      phone: form.phone.trim(),
      orgName: form.orgName.trim() || undefined,
      orgWebsite: form.orgWebsite.trim() || undefined,
      partnershipTypes: selectedTypes,
      orgDescription: form.orgDescription.trim() || undefined,
      whyPartner: form.whyPartner.trim() || undefined,
      preferredContact: form.preferredContact || undefined,
      candidatesSent: Number(form.candidatesSent) || 0,
      comments: form.comments.trim() || undefined,
      consent: form.consent,
    };

    try {
      await createPartner(payload).unwrap();
      setSubmitted(true);
    } catch (err) {
      alert("Failed to submit application. Please try again.");
      console.error("Submission error:", err);
    }
  };

  if (submitted) {
    return (
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="thankYouTitle"
        className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50"
      >
        <div className="bg-white p-8 rounded shadow max-w-md mx-4 text-center">
          <h2 id="thankYouTitle" className="text-2xl font-semibold mb-4">
            Thank you for your submission!
          </h2>
          <p>We will review your application and get back to you soon.</p>
          <button
            type="button"
            className="mt-6 bg-blue-600 text-white px-4 py-2 rounded"
            onClick={() => setSubmitted(false)}
          >
            Close
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-3xl mx-auto p-6 bg-white shadow rounded my-10">
      <h1 className="text-3xl font-bold mb-4">Become Our Partner</h1>
      <p className="mb-6 text-gray-700">
        <strong>About FETC:</strong>
        <br />
        At FETC, we are committed to becoming a global leader in international education and immigration services. We empower students and professionals with the guidance and support needed to achieve academic and career success abroad.
        <br />
        <br />
Partner with us to make global opportunities accessible through trusted services in Study Abroad, Visitor Visas, and English Language Training.
        <br />
        <br />
Please fill out the form below to express your interest in collaborating with us.      </p>

      <form onSubmit={handleSubmit} className="space-y-6" noValidate>
        {/* 1. Full Name */}
        <div>
          <label htmlFor="fullName" className="font-semibold block mb-1">
            1. Full Name <span className="text-red-600">*</span>
          </label>
          <input
            id="fullName"
            name="fullName"
            type="text"
            value={form.fullName}
            onChange={handleChange}
            required
            className="w-full border p-2 rounded"
            placeholder="Enter your full name"
          />
        </div>

        {/* 2. Email */}
        <div>
          <label htmlFor="email" className="font-semibold block mb-1">
            2. Email Address <span className="text-red-600">*</span>
          </label>
          <input
            id="email"
            name="email"
            type="email"
            value={form.email}
            onChange={handleChange}
            required
            className="w-full border p-2 rounded"
            placeholder="Enter your email address"
          />
        </div>

        {/* 3. Phone */}
        <div>
          <label htmlFor="phone" className="font-semibold block mb-1">
            3. Phone Number <span className="text-red-600">*</span>
          </label>
          <input
            id="phone"
            name="phone"
            type="tel"
            value={form.phone}
            onChange={handleChange}
            required
            className="w-full border p-2 rounded"
            placeholder="Enter your phone number"
          />
        </div>

        {/* 4. Org Name */}
        <div>
          <label htmlFor="orgName" className="font-semibold block mb-1">
            4. Organization Name
          </label>
          <input
            id="orgName"
            name="orgName"
            type="text"
            value={form.orgName}
            onChange={handleChange}
            className="w-full border p-2 rounded"
            placeholder="Enter your organization name"
          />
        </div>

        {/* 5. Org Website */}
        <div>
          <label htmlFor="orgWebsite" className="font-semibold block mb-1">
            5. Organization Website
          </label>
          <input
            id="orgWebsite"
            name="orgWebsite"
            type="url"
            value={form.orgWebsite}
            onChange={handleChange}
            className="w-full border p-2 rounded"
            placeholder="Enter your organization's website URL"
          />
        </div>

        {/* 6. Partnership Types */}
        <fieldset className="space-y-2">
          <legend className="font-semibold mb-2">
            6. Type of Partnership Interested In:
          </legend>
          {partnershipOptions.map(({ key, label }) => (
            <label key={key} className="inline-flex items-center mr-4">
              <input
                type="checkbox"
                name={key}
                checked={form.partnershipTypes[key]}
                onChange={handleChange}
                className="mr-2"
                aria-checked={form.partnershipTypes[key]}
              />
              {label}
            </label>
          ))}

          <label className="inline-flex items-center mt-2 block">
            <input
              type="checkbox"
              name="otherChecked"
              checked={form.partnershipTypes.otherChecked}
              onChange={handleChange}
              className="mr-2"
              aria-checked={form.partnershipTypes.otherChecked}
            />
            Other:
            {form.partnershipTypes.otherChecked && (
              <input
                type="text"
                name="otherText"
                value={form.partnershipTypes.otherText}
                onChange={handleChange}
                placeholder="Please specify"
                className="ml-2 border p-1 rounded"
                aria-label="Specify other partnership type"
              />
            )}
          </label>
        </fieldset>

        {/* 7. Org Description */}
        <div>
          <label htmlFor="orgDescription" className="font-semibold block mb-1">
            7. Describe Your Organization:
          </label>
          <textarea
            id="orgDescription"
            name="orgDescription"
            value={form.orgDescription}
            onChange={handleChange}
            rows={3}
            className="w-full border p-2 rounded"
            placeholder="Provide a brief description of your organization and its services"
          />
        </div>

        {/* 8. Why Partner */}
        <div>
          <label htmlFor="whyPartner" className="font-semibold block mb-1">
            8. Why Do You Want to Partner With Us?
          </label>
          <textarea
            id="whyPartner"
            name="whyPartner"
            value={form.whyPartner}
            onChange={handleChange}
            rows={3}
            className="w-full border p-2 rounded"
            placeholder="Share your reasons for wanting to partner with us"
          />
        </div>

        {/* 9. Preferred Communication Method */}
        <fieldset className="space-y-2">
          <legend className="font-semibold mb-2">9. Preferred Communication Method:</legend>
          {communicationMethods.map((method) => (
            <label key={method} className="inline-flex items-center mr-6">
              <input
                type="radio"
                name="preferredContact"
                value={method}
                checked={form.preferredContact === method}
                onChange={handleChange}
                className="mr-1"
                aria-checked={form.preferredContact === method}
              />
              {method}
            </label>
          ))}
        </fieldset>

        {/* 10. Candidates Sent */}
        <div>
          <label htmlFor="candidatesSent" className="font-semibold block mb-1">
            10. Number of Candidates Sent Abroad in the Past Year:
          </label>
          <input
            id="candidatesSent"
            name="candidatesSent"
            type="number"
            value={form.candidatesSent}
            onChange={handleChange}
            min="0"
            className="w-full border p-2 rounded"
            placeholder="Enter the number of candidates sent"
          />
        </div>

        {/* 11. Additional Comments */}
        <div>
          <label htmlFor="comments" className="font-semibold block mb-1">
            11. Additional Comments or Questions:
          </label>
          <textarea
            id="comments"
            name="comments"
            value={form.comments}
            onChange={handleChange}
            rows={3}
            className="w-full border p-2 rounded"
            placeholder="Any other information you would like to provide"
          />
        </div>

        {/* 12. Consent */}
        <div className="flex items-center">
          <input
            id="consent"
            type="checkbox"
            name="consent"
            checked={form.consent}
            onChange={handleChange}
            required
            className="mr-2"
            aria-required="true"
          />
          <label htmlFor="consent" className="font-semibold">
            12. I consent to being contacted regarding partnership opportunities
          </label>
        </div>

        {/* 13. Submit */}
        <button
          type="submit"
          disabled={isLoading}
          className="bg-blue-600 text-white font-semibold py-2 px-6 rounded hover:bg-blue-700 disabled:opacity-50"
        >
          {isLoading ? "Submitting..." : "Submit Application"}
        </button>
      </form>
    </div>
  );
};

export default BecomePartnerForm;
